import { defineComponent as _defineComponent } from 'vue'
import Vue, { computed, ref } from 'vue';
import { useRouter } from 'vue-router/composables';

import StepAnalyse from '@/datura/components/StepAnalyse.vue';
import StepAssessmentName from '@/datura/components/StepAssessmentName.vue';
import StepUpload from '@/datura/components/StepUpload.vue';
import TheContentbar from '@/layout/components/TheContentbar.vue';
import ThePageSkeleton from '@/layout/components/ThePageSkeleton.vue';
import Steps from '@/shared/components/Steps.vue';
import Button from '@/shared/components/buttons/Button.vue';
import ButtonWithArrow from '@/shared/components/buttons/ButtonWithArrow.vue';
import { availableFeatures } from '@/shared/storeDynamicFeatures';
import { useStore } from '@/store';


export default /*#__PURE__*/_defineComponent({
  __name: 'PageNewDroneAssessment',
  setup(__props) {

const t = Vue.i18n.translate;
const stepsList = [
  { number: 1, label: t('Start') },
  { number: 2, label: t('Upload') },
  { number: 3, label: t('Fertigstellen') },
];
const currentStep = ref(0);
const router = useRouter();
const store = useStore();

const pageFeatureEnabled = computed<boolean>(() =>
  store.getters.currentCompaniesHaveFeatureEnabled(availableFeatures.FEATURE_DATURA_CONTROL),
);
const pageFeatureVisible = computed<boolean>(() =>
  store.getters.currentCompaniesHaveFeatureVisible(availableFeatures.FEATURE_DATURA_CONTROL),
);

const assessmentName = ref('');
const uploadComplete = ref(false);
const valid = computed<boolean>(() => {
  switch (currentStep.value) {
    case 0:
      return assessmentName.value.length > 2;
    case 1:
      return uploadComplete.value;
    default:
      return true;
  }
});

function forward(): void {
  if (valid.value) {
    currentStep.value += 1;
  }
}

function onUploadComplete(): void {
  uploadComplete.value = true;
  forward();
}

return { __sfc: true,t, stepsList, currentStep, router, store, pageFeatureEnabled, pageFeatureVisible, assessmentName, uploadComplete, valid, forward, onUploadComplete, StepAnalyse, StepAssessmentName, StepUpload, TheContentbar, ThePageSkeleton, Steps, Button, ButtonWithArrow }
}

})